import { MRT_Row } from "material-react-table"
import { Entity } from "../supportEntitiesTypes"
import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { fetchEntityDetailsById, FetchSupportEntityByIdResponse } from "../supportEntityApi"
import { Skeleton, Box, Grid } from "@mui/material"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { ConnectedEntitiesComponent } from "./ConnectedEntitiesComponent"
import { makeStyles } from "tss-react/mui"
import { theme } from "../../../../theme/theme"

function transformData(data: FetchSupportEntityByIdResponse) {
    return data.entity
}

const useStyles = makeStyles()(() => ({
    detailsContainer: {
        marginLeft: "2.2rem",
        paddingLeft: "1rem",
        gap: "1.5rem",

        "&::before": {
            content: '""',
            position: "absolute",
            left: "2.2rem",
            top: 0,
            bottom: 0,
            width: ".125rem",
            backgroundColor: theme.palette.tailwind.slate[200],
            borderRadius: ".25rem",
        },
    },
}))

export function EntityDetails({ row }: { row: MRT_Row<Entity> }) {
    const { classes } = useStyles()

    const { data: entity, isLoading } = useApiQuery(fetchEntityDetailsById, {
        queryName: "details-for-entity",
        dependencies: {
            entityId: row.original.id,
        },
        select: transformData,
        enabled: !!row.original.id,
    })

    if (isLoading) {
        return <Skeleton width="50%" height={30} />
    }

    return (
        <Box position="relative">
            <Grid container flexDirection="column" className={classes.detailsContainer}>
                {entity?.entityDetails?.connectedCompanies && (
                    <LocalizedStrict id="support-entity-details-connected-companies" attrs={{ title: true }}>
                        <ConnectedEntitiesComponent
                            entities={entity?.entityDetails.connectedCompanies}
                            link="link" // todo: add link
                            title="Connected companies"
                        />
                    </LocalizedStrict>
                )}
                {entity?.entityDetails?.connectedMerchants && (
                    <LocalizedStrict id="support-entity-details-connected-merchants" attrs={{ title: true }}>
                        <ConnectedEntitiesComponent
                            entities={entity?.entityDetails.connectedMerchants}
                            link="link" // todo: add link
                            title="Connected merchants"
                        />
                    </LocalizedStrict>
                )}
                {entity?.entityDetails?.connectedSuppliers && (
                    <LocalizedStrict id="support-entity-details-connected-suppliers" attrs={{ title: true }}>
                        <ConnectedEntitiesComponent
                            borderTop
                            entities={entity?.entityDetails.connectedSuppliers}
                            link="link" // todo: add link
                            title="Connected suppliers"
                        />
                    </LocalizedStrict>
                )}
                {entity?.entityDetails?.connectedDevices && (
                    <LocalizedStrict id="support-entity-details-connected-devices" attrs={{ title: true }}>
                        <ConnectedEntitiesComponent
                            borderTop
                            entities={entity?.entityDetails.connectedDevices}
                            link="link" // todo: add link
                            title="Connected devices"
                        />
                    </LocalizedStrict>
                )}
            </Grid>
        </Box>
    )
}
